import React from "react";
import IvrDateFilter from "../modules/ivr_calls/IvrDateFilter";
import IvrTable from "modules/ivr_calls/IvrTable";
import useStore from "modules/ivr_calls/Store";
import { useState, useEffect } from "react";
import CardDiv from "modules/common/card-div/CardDiv";

function IvrCall() {
  const { ivrData, fetchIvrData } = useStore();
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  const startIvrDate = new Date().toISOString().split("T")[0];
  let endIvrDate = new Date(Date.now() - 30 * 24 * 60 * 60 * 1000)
    .toISOString()
    .split("T")[0];

  useEffect(() => {
    fetchIvrData(startIvrDate, endIvrDate);
  }, [startIvrDate, endIvrDate]);

  useEffect(() => {
    fetchIvrData(startIvrDate, endIvrDate);
    if (startDate && endDate) {
      fetchIvrData(startDate, endDate);
    } else if (startDate == "" && endDate == "") {
      fetchIvrData(startIvrDate, endIvrDate);
    }
  }, [startDate, endDate]);

  return (
    <CardDiv
      title={
        <div className="d-flex justify-content-between">
          {" "}
          <h3>Ivr Calls</h3>
          <div className="float-end">
            <IvrDateFilter
              setStartDate={setStartDate}
              setEndDate={setEndDate}
            />
          </div>
        </div>
      }
      component={
        <>
          <div className="d-flex justify-content-between">
            <div className="">
            </div>
          </div>
          <div className="mt-5 ">
            <IvrTable callData={ivrData} />
          </div>
        </>
      }
    />
  );
}

export default IvrCall;
